'use client';

import { imagePathResolver, ROUTES, useClientConfig } from '@shared/utils';
import { useTranslations } from 'next-intl';
import { CommonCarousel } from '../../../../Carousel/index';
import type { GameDetails } from '../../../../casino/types/types';
import { ClassicGameCard } from '../../../../ClassicGameCard/ClassicGameCard';

type GamesCarouselProps = {
  carouselGames: GameDetails[];
  playButtonText?: string;
};

function GamesCarousel({ carouselGames, playButtonText = 'Play' }: GamesCarouselProps): React.JSX.Element {
  const { baseImgUrl } = useClientConfig();
  const t = useTranslations('landing-pages.crm');

  return (
    <CommonCarousel
      options={{ fullWidth: true, contentMargin: '-ml-2 has-[.carousel-first-item:hover]:ml-2 mr-2', showControls: true }}
      shadcnOptions={{ slidesToScroll: 'auto', breakpoints: {} }}
      className="mt-0"
      data-testid="network-promo-games-carousel"
      title={
        <h2 className="paragraph-strong -mb-5" data-track-name="Title" data-track-carousel-title="Eligible Games">
          {t('eligible_games_title', { count: carouselGames.length })}
        </h2>
      }
    >
      {carouselGames.map(({ image, name, displayName, provider, isFavourite }, index) => {
        return (
          <ClassicGameCard
            className={`dark h-25.5 ${index === 0 ? 'carousel-first-item' : ''}`}
            key={name}
            id={name}
            gameName={displayName}
            backgroundImage={imagePathResolver(image ?? '', baseImgUrl, true)}
            href={ROUTES.CASINO.GAME(name)}
            playButtonText={playButtonText}
            isFavourited={isFavourite}
            infoButtonHref={ROUTES.CASINO.GAME_INFO(name)}
            gameProvider={provider?.[0] ?? ''}
            position={index + 1}
            showFavouriteButton={false}
            showInfoButton={false}
          />
        );
      })}
    </CommonCarousel>
  );
}

export { GamesCarousel, type GamesCarouselProps };
